import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Credit = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '15',
    defaultHeight: '15',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 19 18'
    >
      <path
        stroke={primaryColorToUse}
        strokeWidth='1.059'
        d='M10.164.528c4.822 0 8.707 3.806 8.707 8.471s-3.885 8.47-8.707 8.47S1.456 13.665 1.456 9 5.342.529 10.164.529Z'
      />
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeWidth='1.286'
        d='m6.865 12.855 7.258-7.715M5.216 11.571l4.289-4.5M11.648 10.927l4.289-4.5'
      />
    </svg>
  );
};
